export enum StorageKeys {
  ACCESS_TOKEN = 'access-token',
  BRAND_ANALYSIS = 'brand-analysis'
}
